export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="contact" className="relative">
      {/* Top Gradient */}
      <div className="h-px bg-gradient-to-r from-transparent via-accent-gold/30 to-transparent" />

      <div className="liquid-glass-dark">
        <div className="container mx-auto px-4 py-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {/* Brand Column */}
            <div>
              <h3 className="text-2xl font-bold mb-4">
                <span className="text-accent-gold">Ero</span>
                <span className="text-white">home</span>
              </h3>
              <p className="text-white/60 mb-6 leading-relaxed">
                Experiências exclusivas e personalizadas para quem busca 
                sofisticação e prazer.
              </p>
              <div className="flex gap-4">
                <a
                  href="https://t.me/erohome_bot"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full liquid-glass flex items-center justify-center hover:text-accent-gold transition-colors"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
                  </svg>
                </a>
              </div>
            </div>

            {/* Links Column */}
            <div>
              <h4 className="text-white font-semibold mb-4 uppercase tracking-wider text-sm">
                Links
              </h4>
              <ul className="space-y-3">
                {['Início', 'Produtos', 'Sobre', 'Termos de Uso', 'Privacidade'].map((label) => (
                  <li key={label}>
                    <a
                      href="#"
                      className="text-white/60 hover:text-accent-gold transition-colors duration-300 text-sm"
                    >
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Column */}
            <div>
              <h4 className="text-white font-semibold mb-4 uppercase tracking-wider text-sm">
                Contato
              </h4>
              <ul className="space-y-3">
                <li className="text-white/60 text-sm flex items-center gap-2">
                  <svg className="w-4 h-4 text-accent-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  contato@erohome.com
                </li>
                <li className="text-white/60 text-sm flex items-center gap-2">
                  <svg className="w-4 h-4 text-accent-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  Atendimento 24/7
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/40 text-sm">
              &copy; {currentYear} Erohome. Todos os direitos reservados.
            </p>
            <p className="text-white/40 text-xs">
              +18 - Conteúdo destinado exclusivamente para maiores de idade
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
